"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DEBIT_CARD_LIMIT_BUFFER = exports.TEN_BILLION = exports.vendorRecommendations = exports.allowedParsingDateFormats = exports.CalculationIntervals = exports.CurrencySymbol = exports.BudgetPeriods = void 0;
const models_1 = require("../models");
exports.BudgetPeriods = {
    0: 'Monthly',
    1: 'Quarterly',
    2: 'Yearly',
};
exports.CurrencySymbol = {
    [models_1.CurrencyEnum.USD]: '$',
    [models_1.CurrencyEnum.EUR]: '€',
    [models_1.CurrencyEnum.HUF]: 'Ft',
};
exports.CalculationIntervals = {
    0: 'Current month',
    1: 'Current year',
    2: 'All times',
};
const models_2 = require("../models");
exports.allowedParsingDateFormats = [
    // German format
    'DD.MM.YYYY',
    'D.M.YYYY',
    'D.MM.YYYY',
    'DD.M.YYYY',
    'DD. MM. YYYY',
    'DD. M. YYYY',
    'D. MM. YYYY',
    'DD. MM. YY',
    'D. MM. YY',
    'DD. M. YY',
    'D. M. YYYY',
    'DD.MM.YY',
    'YYYY-MM-DD',
    'YYYY-M-D',
    'YYYY-MM-D',
    'YYYY-M-DD',
    'DD-MM-YYYY',
    'DD-M-YYYY',
    'D-MM-YYYY',
    'D-M-YYYY',
    'DD/MM/YYYY',
    'D/M/YYYY',
    'DD/M/YYYY',
    'D/MM/YYYY',
    'DD/MM/YY',
    'D/M/YY',
    'DD/M/YY',
    'D/MM/YY',
    // US format
    // 'MM/DD/YYYY',
    // 'M/D/YYYY',
    // 'MM/D/YYYY',
    // 'M/DD/YYYY',
    // 'MM/DD/YY',
    // 'M/D/YY',
    // 'MM/D/YY',
    // 'M/DD/YY',
    // Japanese / Hungarian format
    'YYYY.MM.DD.',
    'YYYY.MM.DD',
    'YYYY. MM. DD.',
    'YYYY. MM. DD',
];
exports.vendorRecommendations = Object.values(models_2.RecommendationStringEnum);
exports.TEN_BILLION = 10000000000;
/**
 * In percent.
 */
exports.DEFAULT_DEBIT_CARD_LIMIT_BUFFER = 3;
